// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"TripList_wrapper__3Bkpc","see_more":"TripList_see_more__XY1ZR"};